import { Link, useNavigate } from 'react-router-dom';
import { LoginForm } from '@/pages/auth/LoginForm';
import { MODULE_HUB_PATH } from '@/constants/authRoutes';
import { getPostLoginPath } from '@/utils/moduleScope';
import {
  isFattahOneProductSelectionRequired,
  isPlatformOnboardingRequired,
} from '@/modules/onboarding/onboardingState';
import { resolveOwnerHomePath } from '@/utils/moduleAccess';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { clearAuth } from '@/store/authSlice';
import { notify } from '@/core/toast/notify';

export function FattahLoginPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return (
    <div>
      <LoginForm
        showRegisterLink
        onLoginSuccess={(result) => {
          if (result.masterAdmin) {
            dispatch(clearAuth());
            notify.error('Platform operators must sign in from the master console URL.');
            return;
          }
          if (isFattahOneProductSelectionRequired()) {
            navigate('/onboarding/products', { replace: true });
            return;
          }
          if (isPlatformOnboardingRequired()) {
            navigate('/onboarding', { replace: true });
            return;
          }
          if (result.entryModule) {
            const home = getPostLoginPath(result.entryModule as never, resolveOwnerHomePath(result.enabledModules ?? []));
            navigate(home, { replace: true });
            return;
          }
          navigate(resolveOwnerHomePath(result.enabledModules ?? []), { replace: true });
        }}
      />
      <p className="mt-6 text-center text-xs text-slate-500 dark:text-slate-400">
        <Link to={MODULE_HUB_PATH} className="font-medium text-primary-600 hover:underline dark:text-primary-400">
          Choose a product to sign in
        </Link>
      </p>
    </div>
  );
}
